exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".turnstileChallenge__wrapper___FNFIU {\n  display: inline-block;\n  min-height: 65px;\n  min-width: 300px; }\n", ""]);

// exports
exports.locals = {
	"wrapper": "turnstileChallenge__wrapper___FNFIU"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/TurnstileChallenge/turnstileChallenge.scss
// module id = 4505
// module chunks = 6